import styled from 'styled-components';
import DropDown from '@/trio-ui/Dropdown';

export const CustomDropdown = styled(DropDown)`
  width: 100%;
  margin-right: 8px;
  margin-bottom: 0;

  &:not(&:last-of-type) {
    margin-bottom: 0;
  }

  label {
    flex: initial;
    margin-right: 8px;
  }

  > div {
    max-width: initial;
    width: unset;
  }
`;
